module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters,
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "关键词："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入店铺名称、负责人、负责人联系电话"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "options": _vm.options,
      "placeholder": "请选择城市",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.chengshi),
      callback: function($$v) {
        _vm.$set(_vm.filters, "chengshi", $$v)
      },
      expression: "filters.chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "开店日期："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "title": _vm.value6,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "状　态："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.statedarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "店铺类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.shopType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "shopType", $$v)
      },
      expression: "filters.shopType"
    }
  }, _vm._l((_vm.shopTypeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("店铺管理")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [(_vm.authority.indexOf('enabledbatch') > -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium",
      "data-btnmark": "enabledbatch"
    },
    on: {
      "click": function($event) {
        return _vm.BBStatus(1)
      }
    }
  }, [_vm._v("启用")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('disablebatch') > -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium",
      "data-btnmark": "disablebatch"
    },
    on: {
      "click": function($event) {
        return _vm.BBStatus(2)
      }
    }
  }, [_vm._v("停用")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('openbatch') > -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium",
      "data-btnmark": "openbatch"
    },
    on: {
      "click": function($event) {
        return _vm.OpenShop(1)
      }
    }
  }, [_vm._v("开店")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('closebatch') > -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium",
      "data-btnmark": "closebatch"
    },
    on: {
      "click": function($event) {
        return _vm.OpenShop(2)
      }
    }
  }, [_vm._v("闭店")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('setlevel') > -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium",
      "data-btnmark": "setlevel"
    },
    on: {
      "click": function($event) {
        return _vm.OpenBrandBusinessSetType()
      }
    }
  }, [_vm._v("设置店铺等级")]) : _vm._e(), _vm._v(" "), (_vm.isenterpriseadmin == 1 && _vm.authority.indexOf('add') > -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium",
      "data-btnmark": "add"
    },
    on: {
      "click": function($event) {
        return _vm.addPartner()
      }
    }
  }, [_vm._v("添加店铺")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.imageData,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.Name
          }
        }, [_vm._v(_vm._s(scope.row.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.CityName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.BbTypeName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人姓名",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.Contacts))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人电话",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.Phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属主体",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.EName
          }
        }, [_vm._v(_vm._s(scope.row.EName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺级别",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.TypeName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开店日期",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.OpenTime))]
      }
    }])
  }), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "店铺状态",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: {
            red: scope.row.StatusName == '过期'
          }
        }, [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }], null, false, 2897634287)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "280px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "action_container"
        }, [(_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('span', {
          style: (scope.row.PaidPromotionDataOpen ? 'color: #F56C6C' : 'color: #3396fb'),
          on: {
            "click": function($event) {
              return _vm.handleSwitch(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-data-line"
        }), _vm._v(" " + _vm._s(scope.row.PaidPromotionDataOpen ? "关数据" : "开数据") + "\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('edit') > -1 && (scope.row.StatusId == 1 || scope.row.StatusId == 2 || scope.row.StatusId == 3)) ? _c('p', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "edit"
          },
          on: {
            "click": function($event) {
              return _vm.chakan(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 管理\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('enabledordisable') > -1 && (scope.row.StatusId == 1 || scope.row.StatusId == 2)) ? _c('p', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "enabledordisable"
          },
          on: {
            "click": function($event) {
              return _vm.xiugai(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.StatusId == 1 ? 'el-icon-remove-outline' : 'el-icon-circle-check'
        }), _vm._v("\r\n                " + _vm._s(scope.row.StatusId == 1 ? '停用' : '启用') + "\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.authority.indexOf('openone') > -1 && (scope.row.StatusId == 1)) ? _c('p', {
          staticClass: "handle",
          attrs: {
            "data-btnmark": "openone"
          },
          on: {
            "click": function($event) {
              return _vm.setUp(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-bell"
        }), _vm._v("\r\n                " + _vm._s(scope.row.IsOpen == 1 ? "闭店" : "开店") + "\r\n              ")]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdd),
      expression: "isAdd"
    }],
    staticClass: "add_banner",
    attrs: {
      "span": 24
    }
  }, [_c('section', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticStyle: {
      "width": "102px"
    }
  }, [_vm._v(_vm._s(_vm.typenum == 1 ? "店铺管理新增" : "店铺管理编辑"))])])], 1), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商家名称：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理品牌：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('span', {
    staticClass: "choice",
    on: {
      "click": function($event) {
        return _vm.choice()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBdName),
      expression: "showBdName"
    }]
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("已选择：")]), _vm._v(" "), _vm._l((_vm.xuanze), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(item.Name) + ";")])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司所在地：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ProvinceId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ProvinceId", $$v)
      },
      expression: "form.ProvinceId"
    }
  }, _vm._l((_vm.provinceoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("省")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.CityId),
      callback: function($$v) {
        _vm.$set(_vm.form, "CityId", $$v)
      },
      expression: "form.CityId"
    }
  }, _vm._l((_vm.cityoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("市")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ZoneId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ZoneId", $$v)
      },
      expression: "form.ZoneId"
    }
  }, _vm._l((_vm.Zoneoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("区/县")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "placeholder": "请填写详细地址",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司电话",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.OpeningBank),
      callback: function($$v) {
        _vm.$set(_vm.form, "OpeningBank", $$v)
      },
      expression: "form.OpeningBank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人姓名",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.Contacts),
      callback: function($$v) {
        _vm.$set(_vm.form, "Contacts", $$v)
      },
      expression: "form.Contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "auto-complete": "off",
      "type": "email"
    },
    model: {
      value: (_vm.form.Phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "Phone", $$v)
      },
      expression: "form.Phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作类型：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "200px"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "click": function($event) {
        return _vm.showtime()
      }
    },
    model: {
      value: (_vm.form.operatypeid),
      callback: function($$v) {
        _vm.$set(_vm.form, "operatypeid", $$v)
      },
      expression: "form.operatypeid"
    }
  }, _vm._l((_vm.coperation), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.operatypeid == 2),
      expression: "form.operatypeid==2"
    }],
    attrs: {
      "label": "合作周期：",
      "prop": ""
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "placeholder": "",
      "editable": false,
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line dur_title",
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "",
      "editable": false,
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "回款类型：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "400px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.huikuanid),
      callback: function($$v) {
        _vm.$set(_vm.form, "huikuanid", $$v)
      },
      expression: "form.huikuanid"
    }
  }, _vm._l((_vm.huikuanoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-22px"
    },
    attrs: {
      "label": "开户银行支行所在地：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "label-width": "150px;",
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ProvinceylId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ProvinceylId", $$v)
      },
      expression: "form.ProvinceylId"
    }
  }, _vm._l((_vm.provinceoptions1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("省")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.CityylId),
      callback: function($$v) {
        _vm.$set(_vm.form, "CityylId", $$v)
      },
      expression: "form.CityylId"
    }
  }, _vm._l((_vm.cityoptions1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("市")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ZoneylId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ZoneylId", $$v)
      },
      expression: "form.ZoneylId"
    }
  }, _vm._l((_vm.Zoneoptions1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("区/县")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行名称：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.BankName),
      callback: function($$v) {
        _vm.$set(_vm.form, "BankName", $$v)
      },
      expression: "form.BankName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号名称：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "auto-complete": "off",
      "type": "tel"
    },
    model: {
      value: (_vm.form.accountName),
      callback: function($$v) {
        _vm.$set(_vm.form, "accountName", $$v)
      },
      expression: "form.accountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司银行账号：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "auto-complete": "off",
      "type": "tel"
    },
    model: {
      value: (_vm.form.BankNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "BankNo", $$v)
      },
      expression: "form.BankNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号：",
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "email",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.TaxpayerAccount),
      callback: function($$v) {
        _vm.$set(_vm.form, "TaxpayerAccount", $$v)
      },
      expression: "form.TaxpayerAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-left": "130px"
    }
  }, [(_vm.save) ? _c('p', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.showBan()
      }
    }
  }, [_vm._v("新增")]) : _c('p', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.editBan()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('p', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.closeBan()
      }
    }
  }, [_vm._v("取消")])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "overflow",
    staticStyle: {
      "width": "1545px",
      "margin-left": "205px",
      "margin-top": "50px"
    },
    attrs: {
      "title": "代理品牌",
      "visible": _vm.outerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.outerVisible = $event
      }
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入关键字",
      "type": "email"
    },
    model: {
      value: (_vm.key1),
      callback: function($$v) {
        _vm.key1 = $$v
      },
      expression: "key1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.find()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticClass: "span",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticClass: "span",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.outerVisible = false
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bdname"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("品牌名称")])]), _vm._v(" "), _c('div', {
    staticClass: "check_box"
  }, [
    [_c('div', {
      staticStyle: {
        "margin": "15px 0"
      }
    }), _vm._v(" "), _c('el-checkbox-group', {
      attrs: {
        "fill": "#F56C6C",
        "text-color": "#fff"
      },
      on: {
        "change": _vm.handleCheckedCitiesChange1
      },
      model: {
        value: (_vm.checkedCities),
        callback: function($$v) {
          _vm.checkedCities = $$v
        },
        expression: "checkedCities"
      }
    }, _vm._l((_vm.cities), function(city, index) {
      return _c('el-checkbox', {
        key: index,
        staticClass: "shezhi",
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "text-color": "#F56C6C",
          "label": city,
          "title": city.Name
        }
      }, [_vm._v(_vm._s(city.Name))])
    }), 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "allchange"
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "indeterminate": false,
      "text-color": "#F56C6C"
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('span', {
    ref: "clear",
    staticClass: "span1",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("清空")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "30%",
      "title": "内层 Dialog",
      "visible": _vm.innerVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认",
      "visible": _vm.dialogVisible1,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible1 = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "140px",
      "display": "inline-block",
      "height": "100px",
      "line-height": "100px"
    }
  }, [_vm._v("代理品牌选择完成，您是否选择确认？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisible1 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sure1()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消",
      "visible": _vm.dialogVisible2,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "display": "inline-block",
      "height": "100px",
      "line-height": "100px"
    }
  }, [_vm._v("代理品牌选择完成，取消后将不记载您的数据，您是否确定取消么？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisible2 = false;
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sure2()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "清空",
      "visible": _vm.dialogVisible3,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible3 = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "85px",
      "display": "inline-block",
      "height": "100px",
      "line-height": "100px"
    }
  }, [_vm._v("清空后将不保留您选择的代理品牌结果，您是否确认？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisible3 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clear1()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisibledelete,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledelete = $event
      }
    }
  }, [_c('span', [_vm._v("确定删除么？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.deletesure()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisibledelete = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "佣金设置",
      "visible": _vm.dialogVisible,
      "center": "",
      "custom-class": "normal_dialog",
      "width": "490px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input_item"
  }, [_c('label', [_vm._v("店铺分佣比例：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "2",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    on: {
      "change": _vm.fenyongnum
    },
    model: {
      value: (_vm.enterfenyong),
      callback: function($$v) {
        _vm.enterfenyong = $$v
      },
      expression: "enterfenyong"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fu_hao"
  }, [_vm._v("%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input_item"
  }, [_c('label', [_vm._v("旗下共创端分佣比例：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "",
      "disabled": true,
      "maxlength": "2",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    on: {
      "change": _vm.gongchuangnum
    },
    model: {
      value: (_vm.entergongchaung),
      callback: function($$v) {
        _vm.entergongchaung = $$v
      },
      expression: "entergongchaung"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fu_hao"
  }, [_vm._v("%")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "confirm_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setyongjin
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancle_btn",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "设置店铺付款订单微信收款账户",
      "center": true,
      "width": "35%",
      "visible": _vm.isToExamine
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.translateLoading),
      expression: "translateLoading"
    }],
    staticClass: "imgDialog"
  }, [_c('img', {
    attrs: {
      "src": _vm.showImageUrl
    }
  }), _vm._v(" "), _c('p', [_vm._v("已绑定收款账户员工: "), _c('span', [_vm._v("用户名: " + _vm._s(_vm.BindWxStaffName) + " 用户电话: " + _vm._s(_vm.BindWxStaffPhone) + " ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("关闭")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设置合作模式",
      "center": true,
      "visible": _vm.hezuo,
      "width": "33%"
    },
    on: {
      "update:visible": function($event) {
        _vm.hezuo = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticClass: "findform",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "合作模式：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.operatypeid),
      callback: function($$v) {
        _vm.$set(_vm.form, "operatypeid", $$v)
      },
      expression: "form.operatypeid"
    }
  }, _vm._l((_vm.coperation), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.form.operatypeid == 2),
      expression: "this.form.operatypeid == 2"
    }],
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "合作时间：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changtime
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "回款类型：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.huikuanid),
      callback: function($$v) {
        _vm.$set(_vm.form, "huikuanid", $$v)
      },
      expression: "form.huikuanid"
    }
  }, _vm._l((_vm.orderarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "border": "none"
    },
    on: {
      "click": function($event) {
        _vm.hezuo = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.CooperationType
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "overflow",
    attrs: {
      "title": "店铺等级",
      "visible": _vm.setType,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.setType = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._l((_vm.effectiveTypes), function(r_effectiveType, i) {
    return _c('el-radio-group', {
      key: i,
      model: {
        value: (_vm.effectiveType),
        callback: function($$v) {
          _vm.effectiveType = $$v
        },
        expression: "effectiveType"
      }
    }, [_c('el-radio', {
      staticStyle: {
        "margin-left": "15px"
      },
      attrs: {
        "label": r_effectiveType.id
      }
    }, [_vm._v(_vm._s(r_effectiveType.name))])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.setType = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.setstorelevel
    }
  }, [_vm._v("确认")])], 1)], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7aa34599!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/brand.vue
// module id = 1720
// module chunks = 3